import { useSignalWS } from "@/signal/use-signal";
import { useNetworkState } from "@uidotdev/usehooks";
import { ReadyState } from "react-use-websocket";

export function useSignalStatus() {
  const taskWs = useSignalWS("Task");
  const appu4dmWs = useSignalWS("AppU4DM");
  const network = useNetworkState();

  const instantiating =
    taskWs.readyState === ReadyState.UNINSTANTIATED ||
    appu4dmWs.readyState === ReadyState.UNINSTANTIATED;

  const connecting =
    instantiating ||
    taskWs.readyState === ReadyState.CONNECTING ||
    appu4dmWs.readyState === ReadyState.CONNECTING;

  const connected =
    network.online &&
    taskWs.readyState === ReadyState.OPEN &&
    appu4dmWs.readyState === ReadyState.OPEN;

  const disconnected = !network.online || (!connected && !connecting);

  const hasError =
    !!taskWs.lastError || !!appu4dmWs.lastError || !network.online;

  return {
    hasError,
    connecting,
    connected,
    disconnected,
    taskWs,
    appu4dmWs,
    network,
  };
}
